import { EMPTY } from 'rxjs';
import { Observable } from 'rxjs';
import { EventService } from '@biletix/core/services/event.service';
import {TicketSaleService} from "@biletix/core/services/ticket-sale.service";
import { Component, Input, OnInit, ViewChild, Inject } from '@angular/core';
import {environment} from "@biletix/env";
import { InterestedEvent } from '@biletix/core/models/event/interested-events.model';
import { AbstractionComponent } from '@biletix/core/common/abstraction-component';
import { ShoppingCart } from '@biletix/core/models/shopping-cart/shopping-cart.model';
import { ProfileCampaign } from '@biletix/core/models/event/profile-campaign.model';
import { SwiperComponent } from "swiper/angular";
import SwiperCore, { Navigation, Pagination, Scrollbar, A11y, Virtual, Zoom, Autoplay, Thumbs, Controller, Lazy } from 'swiper';
import {ViewportScroller} from "@angular/common";
import { RouterService } from '@biletix/core/services/router.service';
import { ShoppingItem } from '@biletix/core/models/shopping-cart/shopping-item.model';
import { Router } from '@angular/router';
import { ImageUrlManager } from '@biletix/core/common/helper/image-url-manager';
import { APP_BASE_HREF } from "@angular/common";


SwiperCore.use([
  Navigation,
  Pagination,
  Scrollbar,
  A11y,
  Virtual,
  Zoom,
  Autoplay,
  Thumbs,
  Controller,Lazy
]);



@Component({
  selector: 'btx-interested-events',
  templateUrl: './interested-events.component.html',
  styleUrls: ['./interested-events.component.scss'],
  standalone: false
})
export class InterestedEventsComponent extends AbstractionComponent implements OnInit {


  breakpoints = {
    1: { slidesPerView: 1, spaceBetween: 20 },
    640: { slidesPerView: 2, spaceBetween: 20 },
    959: { slidesPerView: 3, spaceBetween: 20 },
  };
  firstItem: ShoppingItem | any;
  interestedEvents: InterestedEvent[] = [];
  profileCampaign: ProfileCampaign | undefined;
  profileCampaignImage: string = '';
  slideStart: boolean = false;
  readonly MAX_EVENTS: number = 10;

  @Input() shoppingCart?: ShoppingCart;
  @Input() region?: string;
  @Input() lang?: string;

  interestedEvents$: Observable<InterestedEvent[]> = EMPTY;
  constructor(private eventService: EventService,
    @Inject(APP_BASE_HREF) private baseHref: string,
    private viewportScroller:ViewportScroller,
     private ticketSaleService: TicketSaleService,
     private routerService: RouterService,
     private router: Router
     ) {
    super();
  }

  @ViewChild(SwiperComponent)
  swiper!: SwiperComponent;


swipePrev() {
  this.swiper.swiperRef.slidePrev();
}
swipeNext() {
  this.swiper.swiperRef.slideNext();
}


  ngOnInit(): void {
    if (this.shoppingCart && this.shoppingCart.campaignId) {
      this.eventService.getInterestedEvents(this.shoppingCart.campaignId).pipe(this.takeUntilDestroy()).subscribe(interestedEventList => {
        if (interestedEventList && interestedEventList.length > 0) {
          const shoppingEventCodes = this.shoppingCart?.shoppingItems.map(item => item.eventCode);
          this.interestedEvents = interestedEventList
            .filter(event => !shoppingEventCodes?.includes(event.eventCode))
            .slice(0, this.MAX_EVENTS);

          if (this.interestedEvents.length > 0) {
            this.eventService.getProfileCampaign(this.interestedEvents[0].profileCampaignId).pipe(this.takeUntilDestroy()).subscribe(prflCmpgn => {
              this.profileCampaign = prflCmpgn;
              this.profileCampaignImage = ImageUrlManager.createValidationImage(prflCmpgn.image, environment.profileCampaignImageBasePath);
            });
          }

          // @To Do Emre kontrol edecek.
          this.slideStart = this.interestedEvents.length > 2;
        }
      });
    }
  }

 get performancePageLink(): string {
   return this.routerService.getPerformancePageUrl(this.firstItem?.eventCode, this.firstItem?.performanceCode);
 }

 generateHref(eventCode?: string, region?: string, lang?: string): string {
  if (!eventCode || !region || !lang) {
      return '';
  }
  return `${this.baseHref}etkinlik/${eventCode}/${region}/${lang}`;
  }

 public handleMissingImage(event: Event) {
  (event.target as HTMLImageElement).setAttribute("src", "");

}
seeDetail(){
  this.viewportScroller.scrollToAnchor("seeDetail");
}

}
